import React, { useState } from 'react';
import ReactPlayer from 'react-player';

function Video({ muteButton, videoUrl, className, controls, loop, playing }) {

    const [muted, setMuted] = useState(true);

    return (
        <div className="relative">
            {/* Video Player */}
            <ReactPlayer
                url={videoUrl}
                className={className ? className : `react-player px-1`}
                light={false}
                width="100%"
                height="100%"
                controls={controls !== undefined ? controls : true}
                loop={loop !== undefined ? loop : false}
                playing={playing !== undefined ? playing : false}
                playsinline={true}
                muted={muted}
            />

            {muteButton && <button
                onClick={() => setMuted((prev)=> !prev)}
                className="absolute top-[80%] md:top-[5.1%] lg:top-[4.6%] xl:top-[4.8%] 2xl:top-[5.1%] right-[1.5%] lg:right-[1%] 2xl:right-[1.5%] bg-black bg-opacity-30 p-1 lg:p-2 rounded-full text-white"
            >
                {muted ?
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 xl:w-7 xl:h-7">
                        <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM17.78 9.22a.75.75 0 1 0-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L20.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z" />
                    </svg>
                    :
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 xl:w-7 xl:h-7">
                        <path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM18.584 5.106a.75.75 0 0 1 1.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 0 1-1.06-1.06 8.25 8.25 0 0 0 0-11.668.75.75 0 0 1 0-1.06Z" />
                        <path d="M15.932 7.757a.75.75 0 0 1 1.061 0 6 6 0 0 1 0 8.486.75.75 0 0 1-1.06-1.061 4.5 4.5 0 0 0 0-6.364.75.75 0 0 1 0-1.06Z" />
                    </svg>
                }
            </button>}

        </div>
    );
}

export default Video;
